module.exports = __webpack_public_path__ + "static/media/individual.a5660d72.svg";